import styled from 'styled-components';
import { Table } from 'components/Table';

import {
  colorGrey400,
  colorBlack900,
  colorWhite,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';

import { H2, Paragraph } from 'components/Typography';
import {
  CurrContent,
  Currency,
  DiffWrapper,
  TableFooter,
} from 'components/Table/styles';

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  flex-direction: column;

  @media all and ${mediaQueryMobileLargeMin} {
    ${({ cardType }) =>
      cardType !== 'all' &&
      `
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        & > div {
          margin: 0;
        }
    `};
  }
`;

export const TitleWithDateWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Title = styled(H2)`
  font-family: ${fontFamilySecondary};
  font-size: 18px;
  line-height: 24px;
  margin-right: auto;
  width: 100%;

  @media all and ${mediaQueryMobileLargeMin} {
    font-size: 20px;
    line-height: 28px;
    margin-right: auto;
  }
`;

export const SubTitle = styled.h1`
  font-family: ${fontFamilySecondary};
  font-size: 14px;
  line-height: 24px;
  color: ${colorGrey400};
  font-weight: 700;
`;

export const CurrencyWrapper = styled.section`
  width: 100%;
  position: relative;
  background: ${colorWhite};
  box-shadow: 0px 1px 0px 0px #f5f5f5 inset;
  border-radius: 2px;
  padding: 16px;

  ${({ cardType }) =>
    cardType !== 'all'
      ? `
        margin-top: 8px;

         @media all and ${mediaQueryMobileLargeMin} {
          margin-top: 16px;
        }
        `
      : ''};

  @media all and ${mediaQueryMobileLargeMin} {
    padding: 24px;
  }
`;

export const TextDescription = styled.div`
  font-weight: 400;
  font-family: ${fontFamilyPrimary};
  font-size: 14px;
  line-height: 24px;
  width: 100%;
  color: ${colorBlack900};
`;

export const CurrencyHeader = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  margin-bottom: 16px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const Row = styled.div`
  width: 100%;
  display: flex;

  & button {
    margin: 0;
    height: 40px;
    line-height: 39px;
    width: 100%;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    width: auto;
    flex-direction: row;
    justify-content: flex-end;
    margin-top: 0;

    & button {
      width: 200px;
    }
  }
`;

export const Source = styled(Paragraph)`
  color: ${colorGrey400};
  line-height: 16px;

  ${({ mode }) => {
    if (mode === 'mobile') {
      return `
       display: block;
       
        @media all and ${mediaQueryMobileLargeMin} {
          display: none;
        }
      `;
    }
    if (mode === 'desktop') {
      return `
       display: none;
       
        @media all and ${mediaQueryMobileLargeMin} {
          display: block;
        }
      `;
    }
    return '';
  }}
`;

export const TableColumn = styled.div`
  display: flex;
  flex: auto;
  flex-direction: column;
`;

export const TableAverage = styled(Table)`
  display: flex;
  flex: auto;
  order: 1;
  td {
    padding: 0 8px;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    border-bottom: 1px solid #e6e6e6;

    td {
      padding: 0 16px;
    }
  }

  th {
    padding: 4px 16px;
  }

  ${DiffWrapper} {
    margin-top: 2px;
  }

  ${Currency} {
    width: auto;
  }

  tbody tr:last-child {
    box-shadow: none;
  }

  ${CurrContent} {
    justify-content: flex-start;
    align-items: flex-end;
    flex-direction: row;
    font-size: 16px;
  }
`;

export const TableFooterAverage = styled(TableFooter)`
  order: 2;
  flex-direction: column-reverse;
  align-items: flex-start;

  @media all and ${mediaQueryMobileLargeMin} {
    a {
      margin: 0;
    }
    order: 3;
    flex-direction: row;
  }
`;
